import { SelectList } from '@acies/core';
import NameItemItemRenderer from './name-item-renderer';

export default class NameSelectList extends SelectList<{ name: string }> {
	public constructor() {
		super();
		this.width = 'fill';
		this.height = 'fill';
		this.paddingHorizontal = 0;
		this.paddingVertical = 0;
		this.gapVertical = 4;
		this.ItemRenderer = NameItemItemRenderer;
	}
}
customElements.define('ac-name-select-list', NameSelectList);
